<script>
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    export let label = "";
    export let checked = false;

    function handleChange() {
        dispatch('checkedChanged', { label: label, checked: checked });
    }
</script>

<label class="container">{label}
    <input type="checkbox" bind:checked on:focus on:blur on:change={() => handleChange()}>
    <span class="checkmark"></span>
</label>

<style>
    /* Customize the label (the container) */
    .container {
        display: block;
        position: relative;
        padding-left: 22px;
        margin: 2px 8px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default checkbox */
    .container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 4px;
        left: 0;
        border: 1px solid #888;
        border-radius: var(--border-radius);
        height: 14px;
        width: 14px;
        background-color: #eee;
    }

    /* On mouse-over, add a grey background color */
    .container:hover input ~ .checkmark {
        background-color: #ccc;
    }

    /* When the checkbox is checked, add a blue background */
    .container input:checked ~ .checkmark {
        background-color: #5399D0;
        border-color: #5399D0;
    }

    /* When focused add outline */
    .container input:focus ~ .checkmark {
        box-shadow: 0 0 0px 1px #222;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .container input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .container .checkmark:after {
        left: 4px;
        top: -1px;
        width: 4px;
        height: 11px;
        border: solid white;
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
</style>